module.exports = __webpack_public_path__ + "static/media/stacy.6300e257.png";